export const googleLoginApiErrorSelector = state => state.general.get('googleLoginError')
